import { MatrixLike, Point, Region } from 'core/geometry';

export class ViewTransform
{
  public static fitting(source: Region, frame: Region): ViewTransform
  {
    const scale = frame.width / source.width;

    return new ViewTransform(
        scale,
        new Point(frame.x - source.x * scale, frame.y - source.y * scale));
  }

  constructor(public readonly scale: number, public readonly offset: Point)
  {}

  public pointToViewportSpace(targetPoint: Point): Point
  {
    return new Point(
        targetPoint.x * this.scale + this.offset.x,
        targetPoint.y * this.scale + this.offset.y);
  }

  public pointToTargetSpace(viewportPoint: Point): Point
  {
    return new Point(
        (viewportPoint.x - this.offset.x) / this.scale,
        (viewportPoint.y - this.offset.y) / this.scale);
  }

  public regionToViewportSpace(targetRegion: Region): Region
  {
    return Region.fromTwoOrderedPoints(
        this.pointToViewportSpace(targetRegion.topLeft),
        this.pointToViewportSpace(targetRegion.bottomRight));
  }

  public regionToTargetSpace(viewportRegion: Region): Region
  {
    return Region.fromTwoOrderedPoints(
        this.pointToTargetSpace(viewportRegion.topLeft),
        this.pointToTargetSpace(viewportRegion.bottomRight));
  }

  public composedWith(matrix?: MatrixLike): MatrixLike
  {
    return new DOMMatrixReadOnly(
        [this.scale, 0, 0, this.scale, this.offset.x, this.offset.y])
        .multiply(matrix);
  }
}
